export enum PreBindSignTypeEnum{
  DocuSign = 1,
  Manually = 2
}
